import Vehicles from '../../../services/vehicles'
import Param from '../../../services/param'
import ModalRescueBalance from './modal/modal-rescue-balance.vue'
import Pagination, {
  Page
} from '../../../components/pagination';

export default {
  data() {
    return {
      page: new Page().size(10),
      loading: false,
      plate: undefined,
      arrayVP: new Array(),
      vehiclesBalance: new Array(),
      lastDays: '31',
      showRescue: false,
      rescueData: new Array(),
      feeTax: undefined,
      searchState: undefined,
      totalRescue: 0,
    }
  },
  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
    contractIdCred() {
      const contract =  this.$store.state.contract.contracts.find(contract => contract.plan.planId == 6 || contract.plan.planId == 8);
      return contract.contractId;
    }
  },
  mounted() {
    
    this.doFilter();

    Param.getGeneralParameter({key: 'TAXA_TRANSFERENCIA'}).then(res => {
      this.feeTax = 1 + (res.value / 100);
    }).catch(err => {
      
    });
  },
  methods: {
    handleChangeDate(value) {
      this.lastDays = value;
      this.doFilter(true);
    },
    setCurrentPage(p) {
      this.page = this.page.page(p);
      $('.check-item').each(function () {this.checked = false;});
      this.doFilter();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.doFilter();
    },
    rescueBalance(value) {
      this.showRescue = true;
      this.$nextTick(() => {
        $('#modal-rescue-balance').modal();
      });
    },
    close(fn) {
      // this.rescueData = new Array();
      this.showRescue = false;
      this.totalRescue = 0;
      // $('.check-item').each(function () {this.checked = false;});
      $('#modal-rescue-balance').modal('hide');
      this.$nextTick(() => {
        this.doFilter(true);
      });
    },
    checkAll() {
      // $('.check-item').each(function () {this.checked = false;});
      this.totalRescue = 0;
      let checkAll = document.getElementById('selectAll');
      let value = {};
      if (checkAll.checked) {
        $('.check-item').each(function () {this.checked = true;});
        this.vehiclesBalance.forEach((o, index) => {
          value = {
            index: index,
            contractIdDeb : o.contractIdVp,
            contractIdCred : this.contractIdCred,
            transferValue : o.transferValue,
            feeValue: o.taxValue
          };
          this.totalRescue += o.saldoVp;
          this.rescueData.push(value);
        });
      } else {
        $('.check-item').each(function () {this.checked = false;});
        this.rescueData = new Array();
        this.totalRescue = 0;
      }
    },
    check(id) {
      let value = {
        index: id,
        contractIdCred : this.contractIdCred,
        contractIdDeb : $('#'+id).parents('tr').find('.td-plate span:last-child').text(),
        transferValue : parseInt($('#'+id).parents('tr').find('.text-right span:nth-child(2)').text().replace(/\D+/g, '')),
        feeValue: parseInt($('#'+id).parents('tr').find('.text-right span:last-child').text().replace(/\D+/g, ''))
      };

      if (this.rescueData.length == 0) {
        this.rescueData.push(value);
        this.totalRescue += parseInt($('#'+id).parents('tr').find('.text-right span:first-child').text().replace(/\D+/g, ''));
      } else {
        this.rescueData.filter(o => {
          if (o.index === value.index) {
            document.getElementById(id).checked = false;
            this.rescueData.splice(o, 1);
            this.totalRescue -= parseInt($('#'+id).parents('tr').find('.text-right span:first-child').text().replace(/\D+/g, ''));
          } else {
            this.totalRescue += parseInt($('#'+id).parents('tr').find('.text-right span:first-child').text().replace(/\D+/g, ''));
            this.rescueData.push(value);
          }
        });
      }
    },
    validate() {
      let error = this.errors;

      let filter = {
        // startDate: this.periodStart,
        // endDate: this.periodEnd,
        contractIdAgr: this.contractId,
        page: this.page.build(),
        "pageSize": 6,
        // "pageNumber": 1,
      };

      if (this.lastDays == undefined && (!this.customStart || !this.customEnd || (this.customStart > this.customEnd))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = (this.customStart && this.customEnd) ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!'
        return false;
      }

      if (this.lastDays == undefined && beforeOneYear.validate(moment(this.customStart).format("L"))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
        return false;
      }

      if ( this.lastDays == undefined && this.customStart && this.customEnd  && ( (this.customEnd - this.customStart  ) > (2678400000) ) ) {
        //2678400000 = 31 dias
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período máximo permitido, 31 dias.';
         return false;
      }

      return filter;
    },

    doFilter(clearCache) {
      this.totalRescue = 0;
      this.vehiclesBalance = [];
      this.rescueData = [];

      let filter = this.validate();
      $('.check-item').each(function () {this.checked = false;});

      if (clearCache) {
        this.vehiclesBalance = new Array();
        filter.page = 1;
        this.page = filter.page = this.page.page(1);
      }

      if (filter) {
        let promise = Vehicles.getVehiclesAggregateWithBalance(filter).then(data => {
            this.vehiclesBalance = data.itens;
            this.page = this.page.itemCount(data.total);

            if (data.total && this.vehiclesBalance.length > 0) {
              this.searchState = 'FOUND';
              this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
                $('html, body').stop().animate({
                  scrollTop: $("#table-rescue-balance").offset().top - 110
                }, 1000);
              });
            } else {
              this.searchState = 'NOTFOUND';
            }
          })
          .catch(err => {
            this.searchState = 'NOTFOUND';
          });
        this.$store.dispatch('loading', promise);
      }
    },
  },
  components: {
    Pagination, ModalRescueBalance
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/rescue-balance.js